<template>
  <div>
    <div
      v-if="
        typeof error_messages === 'object' &&
          Object.keys(error_messages).length > 0
      "
      class="alert alert-danger"
    >
      <ul>
        <template v-for="(error, i) in error_messages">
          <span v-bind:key="i">
            <li v-for="(message, ii) in error" v-bind:key="ii">
              {{ message }}
            </li>
          </span>
        </template>
      </ul>
    </div>
    <v-btn
      :to="{ name: 'materialPropertiesCreateUpdate' }"
      class="btn btn-success btn-elevate kt-login__btn-primary text-white"
      >{{ $t("ADD") }} {{ $t("NEWO") }}
      {{ $t("MATERIAL_REQUIREMENT") }}</v-btn
    >

    <v-container>
      <v-row no-gutters class="d-none">
        <v-col cols="4">
          <v-text-field
            v-model="headers.search"
            prepend-inner-icon="search"
            clearable
            :label="$t('SEARCH')"
          ></v-text-field>
        </v-col>

        <v-col cols="6">
          <v-checkbox
            v-model="tableOptions.showSearch"
            :label="$t('SEARCH_BY_COLUMN')"
            class="shrink"
          ></v-checkbox>
        </v-col>

        <v-col class="text-right" cols="2">
          <v-select
            v-model="headers.rows"
            :items="tableOptions.rowsPerPage"
            :label="$t('PER_PAGE')"
            chips
            attach
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="mb-6 t-header">
        <v-col
          v-for="column of headers.columns"
          :key="column.name"
          :cols="column.cols"
        >
          <!-- <span @click="changeOrder(column.name)"> -->
          {{ $t("LABELS." + column.name) }}
          <!-- <span v-if="column.name == headers.order">{{ orderIcon }}</span></span> -->
        </v-col>

        <v-col cols="2">
          {{ $t("OPERATIONS") }}
        </v-col>
      </v-row>

      <div v-show="!isLoadingMaterialProperties">
        <v-row class="mb-6 t-row" v-for="item of items" :key="item.id">
          <v-col
            class="t-col"
            v-for="col of headers.columns"
            :key="col.name"
            :cols="col.cols"
          >
            <template v-if="col.name == 'values'">
              <v-chip
                v-for="value of item[col.name]"
                :key="value.id"
                small
                class="besta spacer"
              >
                {{ value.name }}
              </v-chip>
            </template>
            <template v-else>
              {{ item[col.name] }}
            </template>
          </v-col>
          <v-col
            cols="2"
            class="t-col d-flex justify-content-start operation-container flex-wrap"
          >
            <EditButton
              :id="item.id"
              action-name="materialPropertiesCreateUpdate"
            />
            <LogLink :id="item.id" type="material-details-property" />
            <DeleteButton
              :id="item.id"
              :delete-action="deleteAction"
              :fetch-data="fetchData"
              @response-errors="error_messages = $event"
            />
          </v-col>
        </v-row>
      </div>

      <v-progress-linear
        class="mt-5"
        color="#25bdad"
        buffer-value="0"
        stream
        reverse
        :active="isLoadingMaterialProperties"
      ></v-progress-linear>
    </v-container>
  </div>
</template>

<script>
import _ from "lodash";

import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import {
  GET_MATERIALPROPERTIES,
  DELETE_MATERIALPROPERTIE
} from "@/store/materialProperties.module";

import { mapGetters } from "vuex";
import LogLink from "@/components/Log/LogLink";
import EditButton from "@/components/ActionButtons/EditButton";
import DeleteButton from "@/components/ActionButtons/DeleteButton";

export default {
  name: "ListMaterialProperties",

  components: { LogLink, EditButton, DeleteButton },

  data() {
    return {
      deleteAction: DELETE_MATERIALPROPERTIE,
      action: "materialProperties",
      error_messages: [],
      tableOptions: {
        showSearch: false,
        draggableCols: true,
        selectable: true,
        rowsPerPage: [2, 10, 20, 50],
        maxVisibleButtons: 5
      },
      items: [],
      totalItems: 0,
      totalPages: 0,
      headers: {
        columns: [
          {
            name: "id",
            cols: "1"
          },
          {
            name: "name",
            search: "",
            cols: "3"
          },
          {
            name: "values",
            search: ""
          }
        ],
        search: "",
        rows: 10,
        page: 1,
        order: "id",
        orderType: "desc"
      }
    };
  },
  computed: {
    ...mapGetters(["isLoadingMaterialProperties"]),
    orderIcon: function() {
      let vm = this;

      return vm.headers.orderType == "asc" ? "▲" : "▼";
    }
  },
  watch: {
    "headers.search": _.debounce(function(new_value) {
      let vm = this;

      vm.headers.page = 1;
      if (new_value == null || new_value.length >= 3) {
        vm.fetchData();
      }
    }, 250),
    "headers.rows": _.debounce(function(new_value) {
      let vm = this;
      new_value = parseInt(new_value);
      window.localStorage.setItem(vm.action + "_rows", new_value);

      vm.headers.page = 1;
      vm.fetchData();
    }, 250),
    "headers.page": _.debounce(function() {
      let vm = this;
      vm.fetchData();
    }, 250)
  },
  mounted() {
    let vm = this;

    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$t("MATERIAL_REQUIREMENTS") }]);
    vm.fetchData();
  },
  methods: {
    getOptions: function() {
      let vm = this;

      vm.headers.order =
        window.localStorage.getItem(vm.action + "_order") || "id";
      vm.headers.orderType =
        window.localStorage.getItem(vm.action + "_orderType") || "asc";
      vm.headers.rows = parseInt(
        window.localStorage.getItem(vm.action + "_rows") || 10
      );
    },
    changeOrder: _.debounce(function(key) {
      let vm = this;

      if (vm.headers.order == key) {
        let oType = vm.headers.orderType == "desc";
        // let oType = vm.headers.orderType == "asc" ? "desc" : "asc";

        vm.headers.orderType = oType;
      } else {
        vm.headers.order = key;
      }

      vm.headers.page = 1;
      window.localStorage.setItem(vm.action + "_order", vm.headers.order);
      window.localStorage.setItem(
        vm.action + "_orderType",
        vm.headers.orderType
      );

      vm.fetchData();
    }, 250),
    fetchData: _.debounce(function() {
      let vm = this;

      vm.getOptions();

      vm.$store
        .dispatch(GET_MATERIALPROPERTIES, { payload: vm.headers })
        .then(data => {
          vm.$nextTick(function() {
            vm.items = data.data;
            vm.totalItems = data.recordsTotal;
            vm.totalPages = data.totalPages;
          });
        })
        .catch(response => {
          if (response.status === 404) {
            vm.$notification["success"]({
              message: response.status,
              description: response.message
            });
            vm.$router.push({ name: "materialPropertiesList" });
          }
        });
    }, 500)
  },
  beforeDestroy: function() {
    this.items = null;
    delete this.items;
  }
};
</script>
